import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import { GetSubscriptionsResponse } from './types/get-subscriptions.type';

export const getSubscriptions = async (): Promise<AxiosResponse<GetSubscriptionsResponse>> => {
	const response = await api.get('/account/subscriptions/paid');
	return response;
};
